<template>
  <div class="interact-screen" v-if="interactLoaded && !interactFinished && !interactClose">
    <div :class="{'interact': !this.embedded}"
         style="width: 100%; height: 100%;">
      <div class="interact-dialog" style="width: 100%; height: 100%; margin: 0 auto;">
        <div class="interact-content">
          <div v-if="!interactContentLoaded" class="text-center"
               style="position: absolute; top: 50%; left: 50%; transform: translate(-50%,-50%); z-index: 10000;">
            <i class="loading-spinner loading-spinner-big loading-spinner-green"></i>
          </div>
          <div :class="{'interact-body': !this.embedded, 'embedded-interact-body': this.embedded}">
            <iframe :onload="setContentLoaded()" ref="preChallengeIframe" v-if="ready" :src="src"
                    style="height: 100%" :class="{'embedded': this.embedded}"></iframe>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
    import {mapState} from 'vuex';
    import {services, eventBus} from "../../main"
    import {getTechnologyQuery} from "../../services/Utilities";

    export default {
        name: "PreChallengeInteract",
        props: {
            challenge: {type: [Object], default: () => null},
            language: {type: String, default: () => null},
            embedded: {type: Boolean, default: false},
            uniquenessString: {type: [String], default: null},
        },
        data() {
            return {
                userProfileRequest: {loaded: false, error: null},
                sponsoredChallengeInformationRequest: {loaded: false, error: null},
                src: "",
                interactLoaded: false,
                interactFinished: false,
                interactContentLoaded: false,
                interactClose: false,
            }
        },
        created() {
            if (this.isAuthenticated) {
                this.userProfileRequest = services.userService.getUserProfile();
            }

            eventBus.$on('user-profile-changed', () => {
                this.userProfileRequest = {loaded: false, error: null};
                this.userProfileRequest = services.userService.getUserProfile();
            })
        },
        mounted() {
            if (this.ready) {
              this.interactFinishedHandler();
              return;
            }
            window.addEventListener("message", (event) => {
                if (event.origin !== INTERACTS_API_URL) {
                }
                if (event.data === "interact-finished") {
                    this.interactFinishedHandler();
                }
                if (event.data === "interact-close") {
                    this.interactCloseHandler();
                }
                if (event.data === "pre-challenge-content-ready") {
                    eventBus.$emit("pre-challenge-content-ready")
                }
                if (event.data === "interact-submit-start") {
                    eventBus.$emit("interact-submit-start")
                }
            }, false);
        },
        computed: {
            ready: function () {
              // challenge tunnel interact check
              if (this.challenge !== null) {
                return this.challenge.loaded && !this.challenge.error && this.sponsoredChallengeInformationRequest.loaded && !this.sponsoredChallengeInformationRequest.error && this.userProfileRequest.loaded && !this.userProfileRequest.error && this.challenge.challenge_data.id && this.isAuthenticated;
              }
              // generic interact ready check
              return this.isAuthenticated && this.userProfileRequest.loaded && !this.userProfileRequest.error;

            },
            url: function () {
                if(!this.ready) {
                  return null
                }
                if (typeof window.INTERACTS_API_URL === "undefined" || window.INTERACTS_API_URL === "") {
                    this.interactFinishedHandler();
                    return
                }
                if (this.challenge !== null) {
                  let challengeInteractUrl = `${window.INTERACTS_API_URL}/interacts/${this.challenge.challenge_data.id}/pre_challenge_content/?user_token=${services.auth.getIDToken()}&programming_language=${this.programmingLanguage}&region=${this.region}&profession=${this.profession}`;
                  // add company_id for sponsored challenge interact
                  if (this.sponsoredChallengeInformationRequest.apiData.type === 'SPONSORED' && this.sponsoredChallengeInformationRequest.apiData.companyId) {
                    challengeInteractUrl = `${challengeInteractUrl}&company_id=${this.sponsoredChallengeInformationRequest.apiData.companyId}`;
                  }
                  return challengeInteractUrl;
                }
                let result_url = `${window.INTERACTS_API_URL}/interacts/pre_job_tunnel/?user_token=${services.auth.getIDToken()}&programming_language=${this.programmingLanguage}&region=${this.region}&profession=${this.profession}`;
                if (this.uniquenessString !== null) {
                  result_url = `${result_url}&uniqueness_string=${this.uniquenessString}`;
                }
                return result_url;
            },
            region: function () {
                if (!this.userProfileRequest.loaded) {
                    return;
                }
                if (this.userProfileRequest.error) {
                    return;
                }

                return this.userProfileRequest.user_profile.encoded_region;
            },
            profession: function () {
                if (!this.userProfileRequest.loaded) {
                    return;
                }
                if (this.userProfileRequest.error) {
                    return;
                }

                return this.userProfileRequest.user_profile.profession;
            },
            programmingLanguage: function () {
              if (this.language) {
                return this.language;
              }
              if (this.challenge && this.challenge.loaded && !this.challenge.error) {
                return this.challenge.challenge_data.technology.language
              }
              return null
            },
            ...mapState([
                'isAuthenticated',
            ])
        },
        watch: {
            "ready": function () {
                if (this.ready) {
                    let headers = new Headers({"X-Requested-With": "XMLHttpRequest"});
                    fetch(this.url, {redirect: 'manual', headers: headers}).then((response) => {
                        if (response.status === 200) {
                            this.src = this.url;
                            this.interactLoadedHandler();
                            return;
                        }

                        this.interactFinishedHandler();

                    }).catch((error) => {
                        console.error(error);
                        this.interactFinishedHandler();
                    });
                }
            },
          "challenge.loaded" :function () {
              if (this.challenge && this.challenge.loaded && !this.challenge.error && this.challenge.challenge_data.id) {
                // for sponsored challenges we have to ask for the company which is sponsoring the challenge
                this.sponsoredChallengeInformationRequest = services.companyService.getSponsoringInformationDetails(this.challenge.challenge_data.id);
              }
          }
        },
        methods: {
            interactFinishedHandler: function () {
                this.interactFinished = true;
                this.$emit("interactFinished")
            },
            interactLoadedHandler: function () {
                this.interactLoaded = true;
            },
            setContentLoaded: function () {
                this.interactContentLoaded = true;
            },
            interactCloseHandler: function () {
              this.interactClose = true;
              this.$router.push({
                name: 'challenge-details',
                params: {slug: this.challenge.challenge_data.groupId},
                query: {technology: getTechnologyQuery((this.challenge !== null) ? this.challenge.challenge_data.technology: this.language)}
              })
            },
        }
    }
</script>

<style scoped>
iframe {
    width: 100%;
    height: 300px;
    border: 0;
    overflow: hidden;
}


.interact-body {
    padding: 4rem 0 0 240px;
    height: 100%;
    overflow-y: hidden;
}

.embedded-interact-body {
  min-height: 50vh;
}

@media (max-width: 1024px) {
    .interact-body {
        padding-left: 15px;
    }
}

@media (max-width: 415px) {
    .interact-body {
        padding-left: 0;
    }
}

.interact {
  padding-top: 61px;
}

.interact-content {
    background-color: #F8FBFE !important;
    background-clip: padding-box;
    outline: 0;
    height: 100%;
    border: none;
}

iframe.embedded {
  min-height: 80vh  !important;
}

.embedded-interact-body {
  min-height: 50vh;
  display: block;
}
</style>
